import { IconChevronRight } from "@tabler/icons-react";
import { Group, Stack, Text, ThemeIcon } from "@/components/ui";
import type { AdminSeccion } from "../data/secciones";

export function SeccionCard({ seccion, onClick }: { seccion: AdminSeccion; onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="block w-full rounded-lg border border-border bg-card p-4 text-left transition-all duration-120 hover:-translate-y-0.5 hover:shadow-md"
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = `var(--color-${seccion.color}-400)`;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = "";
      }}
    >
      <Group gap="md" align="flex-start" wrap="nowrap">
        <ThemeIcon variant="filled" color={seccion.color} size="lg" radius="md">
          <seccion.icon size={18} stroke={1.7} />
        </ThemeIcon>
        <Stack gap={4} className="min-w-0 flex-1">
          <Group justify="space-between" wrap="nowrap">
            <Text fw={600} size="sm">
              {seccion.titulo}
            </Text>
            <IconChevronRight size={14} stroke={1.6} className="opacity-40" />
          </Group>
          <Text size="xs" c="dimmed" className="leading-relaxed">
            {seccion.descripcion}
          </Text>
        </Stack>
      </Group>
    </button>
  );
}
